module.exports = __webpack_public_path__ + "static/nau-web-tall.990842e2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/nau-web-tall.woff2
// module id = 281
// module chunks = 114276838955818